
import ajax from '@/utils/ajax';
import { ROBOT_BUSINESS_TEMPLATE_LIST } from '@/utils/api';
function ajaxGetGoodsList(params = {}) {
  return new Promise((resolve) => {
    ajax.post(ROBOT_BUSINESS_TEMPLATE_LIST, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch(() => {
        resolve({
          code: 999,
          data: {},
          msg: '获取更多数据失败',
        });
      });
  });
}

export default ajaxGetGoodsList;
